import { GlobalState } from 'src/redux/store';

export const serviceStandardsSelector = (state: GlobalState) => state.serviceStandards;

export const serviceStandardsSelectorData = (state: GlobalState) =>
    serviceStandardsSelector(state).data;

export const serviceStandardsStatusSelector = (state: GlobalState) =>
    serviceStandardsSelector(state).status;
